import React from 'react';
import Seo, { faqSchema } from '@/components/Seo';
import { FaqSection, EmergencyCta } from '@/components/sections';
import { HOME_FAQS, IMAGES } from '@/lib/site';

const EXTRA = [
  { q: 'How long can water stay hidden behind walls or floors?', a: 'Moisture can remain in cavities and porous materials even when the surface looks dry. Moisture checks can help determine whether additional drying is needed.' },
  { q: 'How long does structural drying take?', a: 'There is no fixed timeline. Drying depends on the materials involved, how wet they are, airflow, temperature, humidity and the size of the affected area.' },
  { q: 'What is the difference between clean water and contaminated water?', a: 'A clean supply-line leak is different from sewage, drain backups or outside floodwater. Contaminated water requires additional safety precautions and may change what materials can be restored.' },
  { q: 'Should I contact my insurance company right away?', a: 'If you may be making a claim, contact your insurer as soon as reasonably possible and follow the requirements in your policy. Restoration professionals can often document affected areas and moisture conditions, but coverage decisions belong to your insurer.' },
  { q: 'Can I stay in my home during water damage cleanup?', a: 'It depends on the source, affected area, electrical risks, contamination and the amount of work required. If there is sewage, electrical danger or unsafe conditions, avoid the affected area until it has been assessed.' },
];

export default function FaqPage() {
  const all = [...HOME_FAQS, ...EXTRA];
  return (
    <>
      <Seo
        title="Water Damage FAQ | Tri-Cities BC"
        description="Straightforward answers about water damage, basement flooding, extraction, drying, mould concerns and insurance documentation in the Tri-Cities."
        schema={faqSchema(all)}
      />
      <section className="relative overflow-hidden bg-navy">
        <img src={IMAGES.basement} alt="Water damage restoration questions and homeowner guidance" className="absolute inset-0 h-full w-full object-cover opacity-50" loading="eager" fetchPriority="high" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-deep/90 via-navy-deep/75 to-navy/25" />
        <div className="container-page relative py-16">
          <span className="inline-block rounded-full bg-water/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-water ring-1 ring-water/20">Frequently Asked Questions</span>
          <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold text-white sm:text-5xl">Straight answers about water damage</h1>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-white/70">Quick guidance for common questions before, during and after a water damage emergency.</p>
        </div>
      </section>
      <FaqSection faqs={all} />
      <EmergencyCta />
    </>
  );
}
